import Text from '@/components/text';
import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const CardDetail: FC<Props> = ({ children }) => {
  return (
    <Box mt={1} mb={2}>
      <Text size="small">{children}</Text>
    </Box>
  );
};

export default CardDetail;
